import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomNameMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomNameMessage = ({ message, className = '' }: RoomNameMessageProps) => {
  const sender = message.sender;
  const name = message.content.name;
  return (
    <div className={`room-name-message ${className}`} style={{ color: '#ffa000', padding: '8px 0' }}>
      {sender ? `${sender} 修改了房间名称为「${name}」` : `房间名称被修改为「${name}」`}
    </div>
  );
}; 